import { Button, Flex, Image, Pill, Skeleton, TextInput } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";
import { Product } from "../../api/Product";
import useProductManager from "../../hooks/useProductManager";
import { RoutePaths } from "../../router";
import {
  enhanceCurrency,
  thousandTransform,
  urlify,
} from "../../utils/formatter";
import { isProductDiscount } from "../../utils/product";

const SearchBarProductItem = ({
  product,
  onClick,
}: {
  product: Product;
  onClick?: () => void;
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(urlify(RoutePaths.Product, product.slug));
    onClick && onClick();
  };
  return (
    <div
      onClick={handleClick}
      className="flex flex-row gap-4 border-b border-solid p-2 hover:bg-neutral-200"
    >
      <div className="w-2/6 ">
        <Image
          className="object-cover aspect-square rounded-md"
          src={product.thumbnailUrl}
        />
      </div>

      {/* Information */}
      <div className="flex flex-col gap-2 flex-1">
        <div>
          <b className="mr-1">{product.name}</b>
          <Pill>{product.categoryName}</Pill>
        </div>
        <span>Đã bán {thousandTransform(product.totalPurchase)}</span>
        <Flex direction={"row"} gap={8}>
          <span className="text-yellow-600 font-bold">
            đ {/* The price at bottom */}
            {Number(
              isProductDiscount(product)
                ? product.prices.minDiscountPrice
                : product.prices.minActualPrice
            )}
          </span>
          {isProductDiscount(product) && (
            <span className="text-black line-through">
              đ {enhanceCurrency(product.prices.minActualPrice as number)}
            </span>
          )}
        </Flex>
      </div>
    </div>
  );
};

export default function SearchBar() {
  const navigate = useNavigate();
  const [debouncedSearchValue, setDebouncedSearchValue] = useDebouncedState(
    "",
    300
  );

  const handleChangeSearch = (e: any) => {
    setDebouncedSearchValue(e.target.value);
  };

  const { data: searchData, isLoading: isSearchLoading } =
    useProductManager().getAllProducts({
      productName: debouncedSearchValue,
      limit: 5,
    });

  const handleViewAllSearchItems = () => {
    navigate(`${RoutePaths.Product}?name=${debouncedSearchValue}`);
    setDebouncedSearchValue("");
  };

  return (
    <div>
      <div className="flex flex-row relative items-end gap-4">
        <TextInput
          label={`Tìm kiếm`}
          defaultValue={debouncedSearchValue}
          onChange={handleChangeSearch}
          className="flex-1"
          placeholder="Popper Mỹ"
          radius={"sm"}
        />
        {/* Close button */}
        {/* <ActionIcon>
          <HiOutlineChevronUp />
        </ActionIcon> */}
        {/* Absolute search key */}
        {debouncedSearchValue !== "" && (
          <div className="absolute top-[64px] w-full bg-neutral-50 z-50 p-4 border border-solid rounded-md shadow-md">
            <div className="font-bold text-neutral-600">
              Kết quả tìm kiếm của: {debouncedSearchValue}
            </div>
            {isSearchLoading ? (
              <div className="flex flex-col gap-2 mt-4">
                {[...new Array(5)].map((_, idx) => {
                  return <Skeleton h={32} key={idx} />;
                })}
              </div>
            ) : (
              <div className="flex flex-col gap-2 mt-4">
                {searchData &&
                  searchData?.items &&
                  searchData.items.map((product) => {
                    return (
                      <SearchBarProductItem
                        key={product.id}
                        product={product}
                        onClick={() => setDebouncedSearchValue("")}
                      />
                    );
                  })}
              </div>
            )}
            <div className="flex flex-row justify-end mt-4">
              <Button onClick={handleViewAllSearchItems}>Xem thêm</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
